import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { ProgressBarSuspenseFallback } from '@vivaldis/web-ui'

const AddEmployeeCertificate = lazy(
  () =>
    import(
      /* webpackChunkName: "AddEmployeeCertificate" */ './screens/AddEmployeeCertificate'
    )
)

const EditEmployeeCertificate = lazy(
  () =>
    import(
      /* webpackChunkName: "EditEmployeeCertificate" */ './screens/EditEmployeeCertificate'
    )
)

const EditEmployeeGeneralInformation = lazy(
  () =>
    import(
      /* webpackChunkName: "EditEmployeeGeneralInformation" */ './screens/EditEmployeeGeneralInformation'
    )
)

const EditEmployeePersonalInformation = lazy(
  () =>
    import(
      /* webpackChunkName: "EditEmployeePersonalInformation" */ './screens/EditEmployeePersonalInformation'
    )
)

const EditEmployeeWageProfile = lazy(
  () =>
    import(
      /* webpackChunkName: "EditEmployeeWageProfile" */ './screens/EditEmployeeWageProfile'
    )
)

const SetEmployeeSafetyAnswer = lazy(
  () =>
    import(
      /* webpackChunkName: "SetEmployeeSafetyAnswer" */ './screens/SetEmployeeSafetyAnswer'
    )
)

const SnoozeMissingCertificate = lazy(
  () =>
    import(
      /* webpackChunkName: "SnoozeMissingCertificate" */ './screens/SnoozeMissingCertificate'
    )
)

const ViewEmployeeProfile = lazy(
  () =>
    import(
      /* webpackChunkName: "ViewEmployeeProfile" */ './screens/ViewEmployeeProfile'
    )
)

export const EmployeeRoutes = () => (
  <Suspense fallback={ProgressBarSuspenseFallback}>
    <Routes>
      <Route
        path=":employeeId/add-employee-certificate"
        element={<AddEmployeeCertificate />}
      />
      <Route
        path=":employeeId/edit-employee-certificate/:certificateId"
        element={<EditEmployeeCertificate />}
      />
      <Route
        path=":employeeId/edit-employee-general-information"
        element={<EditEmployeeGeneralInformation />}
      />
      <Route
        path=":employeeId/edit-employee-personal-information"
        element={<EditEmployeePersonalInformation />}
      />
      <Route
        path=":employeeId/edit-employee-wage-profile"
        element={<EditEmployeeWageProfile />}
      />
      <Route
        path=":employeeId/set-employee-safety-answer/:positionId"
        element={<SetEmployeeSafetyAnswer />}
      />
      <Route
        path=":employeeId/snooze-missing-certificate/:certificateType"
        element={<SnoozeMissingCertificate />}
      />
      <Route
        path=":employeeId/view-employee-profile"
        element={<ViewEmployeeProfile />}
      />
    </Routes>
  </Suspense>
)
